/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

export const validationSchema = Yup.object({
  thumbnail: Yup.string().required('required'),
  identifier: Yup.string().required('required').matches(/^\S*$/, 'no_spaces'),
  i18n: Yup.array().of(
    Yup.object().shape({
      title: Yup.string().required(),
      language: Yup.string().required(),
    }),
  ),
});

export const ignoreApiErrors: string[] = ['duplicate_identifier'];
